module.exports = __webpack_public_path__ + "static/img/shuru.931677f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shuru.png
// module id = 7sez
// module chunks = 1